import { writable } from 'svelte/store';

export const accessToken = writable(localStorage.getItem('accessToken') || null);

accessToken.subscribe((token) => {
  if (token) {
    localStorage.setItem('accessToken', token);
  } else {
    localStorage.removeItem('accessToken');
  }
});